import React from 'react';

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <input
    type="checkbox"
    className={`h-4 w-4 rounded-[4px] accent-paper-accent ${className}`}
    ref={ref}
    {...props}
  />
));

Checkbox.displayName = 'Checkbox';

export { Checkbox };
